// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgFiletypeXls = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 159 206"
    {...props}
  >
    <path
      fill="#999"
      d="M0 4a4 4 0 0 1 4-4h95.807c2.366 0 4.637.932 6.322 2.595l33.193 32.762A9 9 0 0 1 142 41.762V183a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M4 6a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v26.5c0 5.523 4.477 10 10 10h26a2 2 0 0 1 2 2V181a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
    />
    <path
      fill="#999"
      d="M51.622 64.865H34.864a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2H51.62a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M79.297 64.865H62.541a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2h16.756a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M106.973 64.865H90.216a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2h16.757a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M51.622 83.892H34.864a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2H51.62a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M79.297 83.892H62.541a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2h16.756a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M106.973 83.892H90.216a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2h16.757a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M51.622 102.919H34.864a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2H51.62a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M79.297 102.919H62.541a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2h16.756a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M106.973 102.919H90.216a2 2 0 0 0-2 2v9.838a2 2 0 0 0 2 2h16.757a2 2 0 0 0 2-2v-9.838a2 2 0 0 0-2-2M23 166a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H27a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M100.238 195.006h-8.094c-1.64 0-2.619.027-3.597.08.159-.979.212-2.011.212-3.677v-13.833c0-1.825-.053-2.857-.212-4.074h4.814c-.185 1.614-.212 1.958-.212 4.021v13.569h7.089c1.825 0 2.751-.053 3.914-.185v4.284c-.767-.105-2.248-.185-3.914-.185M108.152 188.606l4.603-.45c.105 1.084.264 1.587.714 2.142.714.926 1.957 1.429 3.518 1.429 2.301 0 3.756-1.058 3.756-2.751 0-.82-.344-1.481-1.032-1.905-.82-.529-1.64-.793-4.523-1.454-2.248-.529-3.121-.873-4.126-1.587-1.481-1.111-2.275-2.725-2.275-4.682 0-3.888 3.095-6.348 7.988-6.348 3.148 0 5.528.952 6.904 2.751.661.899 1.005 1.666 1.349 3.227l-4.656.502c-.132-.82-.317-1.216-.687-1.693-.609-.714-1.667-1.11-2.936-1.11-2.063 0-3.439 1.005-3.439 2.512 0 .714.318 1.296.899 1.72.582.37 1.111.555 2.487.872 2.883.609 4.152.953 5.21 1.429 1.085.476 2.064 1.296 2.672 2.301.529.873.793 1.931.793 3.2 0 4.312-3.015 6.772-8.305 6.772-3.412 0-5.978-.953-7.38-2.725-.872-1.084-1.243-2.089-1.534-4.152M74.73 186.833l-3.306 5.079c-.688 1.084-1.217 1.931-1.852 3.094h-5.845c1.587-1.983 1.93-2.433 2.724-3.544l5.607-7.856-4.787-6.718c-.952-1.322-1.666-2.275-2.592-3.386h5.74c.37.847 1.031 2.064 1.825 3.227l2.539 3.809 2.46-3.835c1.031-1.587 1.401-2.248 1.798-3.201h5.713c-.846 1.032-1.507 1.931-2.486 3.307l-4.84 6.797 5.607 7.856c.82 1.164 1.508 2.037 2.725 3.544h-5.872a44 44 0 0 0-1.826-3.094zM56 190.431h4.576v4.576H56z"
    />
  </svg>
)
export default SvgFiletypeXls
